
import { defineComponent, reactive, onMounted, computed, ref, nextTick, watch, onUnmounted } from "vue";
import { ethitransService } from "@/services/EthitransService";
import { common } from "@/common/services/Common";
import { useRoute, useRouter } from "vue-router";
import SuccessfulModalCustom from "@/components/modal/SuccessfulModalCustom.vue";
// import Multiselect from 'vue-multiselect';
import ErrorList from "@/components/commonDesign/ErrorList.vue";
import Editor from "@/components/mention/Editor.vue";
import SignaturePadModal from "@/components/modal/SignaturePadModal.vue";
import SignatureUploadModal from "@/components/modal/SignatureUploadModal.vue";
import VoiceToText from "@/components/VoiceToText.vue";
// import GoogleAddressCustomer from "../commonDesign/GoogleAddressCustomer.vue";
import AppPhoneNumberInput from "@/components/commonDesign/AppPhoneNumberInput.vue";
import { useI18n } from 'vue-i18n';
import ToDoChatChannelModel from "../todo/ToDoChatChannelModel.vue";
import AppEmailAndPhoneNumberValidate from "../commonDesign/AppEmailAndPhoneNumberValidate.vue";
import { validationService } from "@/common/ValidationService";
import { useDebouncedRef } from "@/common/useDebouncedRef";


export default defineComponent({
    name: "ProjectWorkflowSendJobEstimation",
    props: {
        estimationId: String,
        projectName: String,
    },
    components: {
        // Multiselect,
        SuccessfulModalCustom,
        ErrorList,
        Editor,
        SignaturePadModal,
        SignatureUploadModal,
        VoiceToText,
        // GoogleAddressCustomer,
        AppPhoneNumberInput,
        ToDoChatChannelModel,
        AppEmailAndPhoneNumberValidate

    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const router = useRouter();
        // const {
        //     params: { estimationId },
        // } = useRoute();
        const isInvalid = ref(false);
        const isPhoneInvalid = ref(false);
        const canvas: any = ref(null);
        const signaturePad: any = null;
        const latitude = ref<number>(36.0755227);  // Default latitude
        const longitude = ref<number>(-79.8203066);  // Default longitude
        const address = ref<string>('');
        const showMap = ref<boolean>(false);
        const signatureInput = ref<HTMLInputElement | null>(null);
        const customerList = ref([]);
        const {
            params: { projectId },
        } = useRoute();


        const updateLatitude = (newLatitude: number) => {
            latitude.value = newLatitude;
        };

        const updateLongitude = (newLongitude: number) => {
            longitude.value = newLongitude;
        };
        const customer = reactive({
            // eslint-disable-next-line @typescript-eslint/camelcase
            address_line1: ''

        });

        const updateAddress = (newAddress: string) => {
            // eslint-disable-next-line @typescript-eslint/camelcase
            customer.address_line1 = newAddress;
        };
        const enteredValue = ref('');
        const clearInputValue = ref(false);


        const state = reactive({
            selectedChannel: {
                id: "",
                name: ""
            } as any,
            form: {
                firstName: '',
                lastName: '',
                contact: ''
            },
            errors: {
                firstName: '',
                lastName: '',
                contact: '',
            },
            activeTab: 'projectstb',
            estimationPreview: false,
            selectItems: [] as any,
            estimationId: props.estimationId,
            selectUnitId: '' as any,
            selectSubItemIndex: '' as any,
            selectItemIndex: '' as any,
            selectSubItem: '' as any,
            approveByAll: false,
            sendData: {} as any,
            mainItem: '' as any,
            projectId: '' as any,
            selectedDate: '' as any,
            fields: {
                description: true,
                markup: true,
                quantity: true,
                unit: true,
                cost: true,
                allowance: true,
                total: true,
                subTotal: true,

            } as any,
            ui: {
                projectChannelPage: 1,
                projectChannelLastPage: 1,
                projectListLastPage: 1,
                projectListPage: 1,
                channelMemberPage: 1,
                channelMemberLastPage: 1,
                channelListPage: 1,
                channelListLastPage: 1,
                channelListHasMore: true,
                isHideChannelPart: false,
                showEditCustomerModal: false,
                isLoading: {
                    isEdit: false,
                    getItemList: false,
                    isUnitEdit: false,
                    getUnit: false,
                    signaturePadLoad: false,
                    isCompanyEdit: false,
                    isRemoveCustomer: false,
                    checkSignature: false,
                    customerChannelList: false,
                    customerChannelMemberList: false,
                    projectList: false,
                    projectChannelList: false
                },
                isPostLoading: {
                    delete: false,
                    addUnite: false,
                    checkSignature: false,
                    sendJobEstimation: false,
                    createCompanyIfno: false,
                },
                searchQuery: {
                    customerChannel: '',
                    channelMembers: '',
                    projects: ''
                },
                errors: {
                    errorList: {
                        createUnit: [] as any,
                        sendJobEstimation: [] as any,
                        createCompanyIfno: [] as any,
                    },
                    validationErrorList: {
                        itemName: "",
                        unitName: "",
                    },
                    companyEroor: "",
                    hasError: false,
                },
            },
            data: {
                selectedFilterProjectTab: 'channel',
                selectedFilterCustomerTab: 'channel',
                selectedMembers: [] as any,
                selectedFilter: 'channel',
                customerToEdit: "" as any,
                customerToEditIndex: "",
                removeUser: {} as any,
                successFulMessage: "",
                showSuccesCustomModal: false,
                showChatChannelModal: false,
                selectedCustomers: [] as any,
                formAddedMembers: [] as any,
                customerChannels: [] as any,
                projectChannels: [] as any,
                customerProjects: [] as any,
                apiChannelMembers: [] as any,
                channelMembers: [] as any,
                allCustomer: [] as any,
                allPhones: [] as any,
                selectedMemberIds: [] as any,
                uploadSignature: {} as any,
                haveProfileSign: false,
                useProfileSign: false,
                showSignaturePad: false,
                showSignatureUpload: false,
                uploadSignatureFile: "" as any,
                signatureLink: "" as any,
                modifiedCreatedDate: "" as any,
                cropImage: "",
                note: "",
                newUploadImge: "" as any,
                cropSignature: "" as any,
                lineItems: [] as any,
                unitLists: [] as any,
                company: "" as any,
                signatureFileName: "" as any,
                selectedChannelUuid: '',
                selectedProjectUuid: '' as any,
                companyInfo: {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_name: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_email: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_phone_number: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_address: "",
                    acknowledgement: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    legal_statement: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    logo: "",
                },
                unit: {
                    name: '',
                    abbreviation: '',
                },
                sendarSignature: "" as any,
                // eslint-disable-next-line @typescript-eslint/camelcase
                signature_link: '' as any,

            },
            mailNotification: false, // Default to true
            smsNotification: false, // Default to false
            mailNotificationError: '',
        });
        const channelMembers = computed(() => {
            const editedIds = new Set(state.data.formAddedMembers.map((m: any) => m.user_id));

            return state.data.apiChannelMembers.filter((m: any) => !editedIds.has(m.user_id));
        });


        const selectedMembers = computed(() => {
            return state.data.selectedMembers
        });

        const formatPhone = (n: string) => `+1 (${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}`;




        function validateEmail() {
            // Regular expression for basic email validation
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            state.ui.errors.hasError = false;

            if (!state.data.companyInfo.company_email.match(emailPattern)) {
                state.ui.errors.companyEroor = 'Please enter a valid email address';
                state.ui.errors.hasError = true;

            } else {
                state.ui.errors.companyEroor = '';
            }
        }
        function closePreviewModal() {
            state.estimationPreview = false;
            $("#previewModal").modal("hide");
        }
        function previewModal() {
            $("#previewModal").modal("show");
            state.estimationPreview = false;

        }
        function estimationPreview() {
            state.estimationPreview = true;
            $("#previewModal").modal("show");
        }
        function gotoListJobEstimation() {
            // router.push({
            //     name: "list-job-estimation",
            //     params: { projectId: state.projectId },
            // });
            emit('back-to-job-estimation-list');
        }

        function showSignaturePad() {
            state.data.showSignaturePad = !state.data.showSignaturePad;
        }

        function hideSignaturePad() {
            state.data.showSignaturePad = !state.data.showSignaturePad;
            $("#signaturePadModal").modal("hide");
        }

        // function hideSignatureUpload() {
        //     state.data.showSignatureUpload = false;
        //     $("#signatureUploadModal").modal("hide");
        // }
        function hideSignatureUpload() {
            state.data.showSignatureUpload = false;
            if (signatureInput.value) {
                signatureInput.value.value = '';
            }
        }
        function uploadSignature(data: any) {
            state.data.uploadSignature = data;
            state.data.signatureLink = "";
            state.data.cropSignature = data;
            state.data.useProfileSign = false;
        }

        // function uploadSignatureFile(event: any) {
        //     state.data.showSignatureUpload = true;
        //     state.data.uploadSignatureFile = event.target.files || event.dataTransfer.files;
        // }
        function uploadSignatureFile(event: any) {
            const files = event.target.files || event.dataTransfer.files;
            if (files && files.length > 0) {
                state.data.uploadSignatureFile = files;
                state.data.showSignatureUpload = true;
                nextTick(() => {
                    if (signatureInput.value) {
                        signatureInput.value.value = '';
                    }
                });
            }
        }


        function readLogo(file: any) {
            const data = {} as any;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                data.file = e.target.result;
                data.filename = file.name.replaceAll(`.${extension}`, "");
                data.extension = extensionLower;
                data.isuploded = false;
                data.size = common.formatBytes(parseInt(file.size));
                state.data.companyInfo.logo = data;
            };
            reader.readAsDataURL(file);
        }


        function uploadLogo(event: any) {
            const files = event.target.files || event.dataTransfer.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                // console.log("FILE CHECK >>>", file);
                // if(file.type)
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                readLogo(file);
            }
        }

        function readImage(file: any) {
            const data = {} as any;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                data.file = e.target.result;
                data.name = file.name.replaceAll(`.${extension}`, "");
                data.extension = extensionLower;
                console.log("CHECK DATA FOR UPLOAD>>", data);
                // state.imageList.push(data);
            };
            reader.readAsDataURL(file);
        }
        const dropFiles = (event: any) => {
            const files = event.target.files || event.dataTransfer.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                readImage(file);
            }
        };

        function readSignature(file: any) {
            const data = {} as any;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                data.base64 = e.target.result;
                data.duplicateFile = false; // data.fileName = file.name;
                data.fileName = file.name.replaceAll(`.${extension}`, "");
                data.extension = extensionLower;
                data.isuploded = false;
                data.tag = [] as any;
                data.size = common.formatBytes(parseInt(file.size));
                // state.data.uploadImageData = data;
                state.data.newUploadImge = data.base64;
                state.data.cropImage = data.base64;
                state.data.signatureFileName = data.fileName;
            };
            reader.readAsDataURL(file);
        }

        function onDocumentChange(event: any) {
            const files = event.target.files || event.dataTransfer.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                // console.log("FILE CHECK >>>", file);
                // if(file.type)
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                readSignature(file);
                $("#updateUpload").modal("show");
            }
        }

        function showUploadImageModel() {
            $("#updateUpload").modal("show");
        }

        function hideShowUploadImageModel() {
            $("#profileUpdate").val("");
            $("#updateUpload").modal("hide");
        }


        function saveSignature() {
            hideShowUploadImageModel();
        }

        function clearSignature() {
            state.data.uploadSignature = "";
            state.data.cropSignature = "";

        }

        // function clearCrop() {
        //     if (!cropper) return;
        //     cropper.clear();
        // }
        // /**
        //  * Reset the default cropping area
        //  */
        // function resetCrop() {
        //     if (!cropper) return;
        //     cropper.reset();
        // }

        // function enableSignaturPad() {

        //     state.ui.isLoading.signaturePadLoad = !state.ui.isLoading.signaturePadLoad;
        //     signaturePad = new SignaturePad(canvas.value);
        // }


        function getProjectDetails() {
            ethitransService
                .getEstimationCreateDetails(state.projectId)
                .then((res: any) => {

                    res.data.data.payers.forEach((user: any) => {
                        const data = {
                            email: user.email,
                            code: user.email,
                            mailNotification: true,
                        };
                        state.data.allCustomer.push(data);
                    });
                    // toggleTourGuide();
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    // state.postLoading = false;
                });
        }

        function getJobestimationDetail() {
            state.ui.isLoading.getItemList = true
            ethitransService
                .getJobestimationDetail(state.estimationId)
                .then((res: any) => {
                    state.selectItems = [];
                    state.sendData = res.data.data;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.projectId = res.data.data.project_id;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.selectedDate = common.formatDateAndTime(res.data.data.created_date);
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.modifiedCreatedDate = common.formatDateAndTime(res.data.data.created_date);
                    state.data.note = res.data.data.note;
                    // state.data.createDate = moment(res.data.data.created_date).format("Y-MM-DD");
                    res.data.data.items.forEach((subItem: any) => {
                        subItem.subTotal = parseFloat(subItem.cost) * parseFloat(subItem.quantity);
                        subItem.selectUnit = state.data.unitLists.filter((unit: any) => unit.id === subItem.unit_id)[0];
                        if (subItem.markup_type == 1) {
                            const parCal = ((parseFloat(subItem.cost) * parseFloat(subItem.quantity)) * parseFloat(subItem.markup)) / 100;
                            subItem.total = parCal + (parseFloat(subItem.cost) * parseFloat(subItem.quantity));
                            subItem.markup = common.takeLimitDigits(subItem.markup);
                        } else {
                            subItem.total = (parseFloat(subItem.cost) * parseFloat(subItem.quantity)) + parseFloat(subItem.markup);
                            subItem.markup = common.usdPriceFormate(subItem.markup);
                        }
                        subItem.total = common.usdPriceFormate(subItem.total);
                        subItem.cost = common.usdPriceFormate(subItem.cost);
                        subItem.subTotal = common.usdPriceFormate(subItem.subTotal);
                        subItem.allowance = subItem.allowance ? common.usdPriceFormate(subItem.allowance) : '-';
                    });

                    state.selectItems = res.data.data.items;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    getProjectDetails();
                    state.ui.isLoading.getItemList = false;
                });
        }

        function fetchCustomerDetails(email: string) {
            ethitransService.detailsByemail(email)
                .then(response => {
                    const selectedCustomers: any = response.data;
                    if (selectedCustomers && selectedCustomers) {
                        const data = selectedCustomers.data;
                        if (data.email) {
                            const customerData = {
                                email: data.email,
                                code: data.email,
                                // eslint-disable-next-line @typescript-eslint/camelcase
                                first_name: data.first_name || '',
                                // eslint-disable-next-line @typescript-eslint/camelcase
                                last_name: data.last_name || '',
                                phone: data.mobile_number || '',
                                // eslint-disable-next-line @typescript-eslint/camelcase
                                address_line1: data.address_line1 || '',
                                mailNotification: true,
                                smsNotification: false,
                            };

                            const existingCustomerIndex = state.data.selectedCustomers.findIndex((customer: any) => ((customer.email === data.email) || (customer.phone === data.mobile_number)));
                            if (existingCustomerIndex !== -1) {
                                // Replace the entire object
                                state.data.selectedCustomers[existingCustomerIndex] = { ...customerData };
                            } else {
                                state.data.selectedCustomers.push(customerData);
                            }
                        }
                    }
                })
                .catch(error => {
                    console.error('Error fetching customer details:', error);
                });
        }



        function addCustomerEmail(data: any) {
            isInvalid.value = false;
            const email = data;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (email == localStorage.getItem("current_user_email")) {
                isInvalid.value = true;
                return false;
            }
            if (!emailRegex.test(email)) {
                isInvalid.value = true;
                return false;
            }
            const existingCustomerIndex = state.data.selectedCustomers.findIndex((customer: any) => customer.email === email);
            if (existingCustomerIndex === -1) {
                // Add new customer to both allCustomer and selectedCustomers
                const addData = {
                    email: email,
                    code: email,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    first_name: '',
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    last_name: '',
                    phone: '',
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    address_line1: '',
                    mailNotification: true,
                    smsNotification: false,
                };

                state.data.allCustomer.push(addData);
                state.data.selectedCustomers.push(addData);

                // Fetch additional details for the new customer
                fetchCustomerDetails(email);
            } else {
                // If email already exists, update the existing customer details
                fetchCustomerDetails(email);
            }

        }

        // function changeValue() {
        //     isInvalid.value = false;
        // }
        function changeValue(selectedCustomer: any) {
            isInvalid.value = false;
            if (selectedCustomer && selectedCustomer.email) {
                fetchCustomerDetails(selectedCustomer.email);
            }
        }

        function addCustomerPhone(data: any) {
            isPhoneInvalid.value = false;
            const phone = data;
            if (phone.length != 10) {
                isPhoneInvalid.value = true;
                return false;
            }
            let userPhone = "";
            const currentUser = localStorage.getItem('current_user_info');
            userPhone = (currentUser != undefined) ? JSON.parse(currentUser).mobile_number : '';
            if (phone == userPhone) {
                isPhoneInvalid.value = true;
                return false;
            }
            const existingCustomerIndex = state.data.selectedCustomers.findIndex((customer: any) => customer.phone === phone);
            if (existingCustomerIndex === -1) {
                // Add new customer to both allCustomer and selectedCustomers
                const addData = {
                    email: "",
                    code: phone,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    first_name: '',
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    last_name: '',
                    phone: phone,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    address_line1: '',
                    mailNotification: true,
                    smsNotification: false,
                };

                state.data.allPhones.push(addData);
                state.data.selectedCustomers.push(addData);

                // Fetch additional details for the new customer
                fetchCustomerDetails(phone);
            } else {
                // If email already exists, update the existing customer details
                fetchCustomerDetails(phone);
            }

        }

        function changePhoneValue(selectedCustomer: any) {
            isInvalid.value = false;
            if (selectedCustomer && selectedCustomer.email) {
                fetchCustomerDetails(selectedCustomer.email);
            }
        }


        function closeSuccessCustomModal() {
            $("#SuccessfulModalCustom").modal("hide");
            gotoListJobEstimation();
        }


        function validateSendInvitation() {
            state.ui.errors.errorList.sendJobEstimation = [];
            state.ui.errors.hasError = false;

            if (selectedMembers.value.length == 0) {
                state.ui.errors.errorList.sendJobEstimation.push("Enter one customer");
            }
            if (!state.data.uploadSignature && !state.data.signatureLink) {
                state.ui.errors.errorList.sendJobEstimation.push("Draw/Upload/ Use your profile Signature");
                state.ui.isPostLoading.checkSignature = true;
            }

            if (
                !state.ui.errors.errorList.sendJobEstimation &&
                !state.ui.errors.errorList.sendJobEstimation.length
            ) {
                state.ui.errors.hasError = false;
            } else if (state.ui.errors.errorList.sendJobEstimation.length != 0) {
                state.ui.errors.hasError = true;
            }
        }

        // function sendJobEstimation() {
        //     state.ui.isPostLoading.sendJobEstimation = false;
        //     state.ui.errors.hasError = false;
        //     state.ui.isPostLoading.checkSignature = false;
        //     validateSendInvitation();
        //     if (state.ui.isPostLoading.sendJobEstimation || state.ui.errors.hasError) return false;
        //     const selectedCustomer = selectedMembers.value.map((customer: any) => ({
        //         ...customer,
        //         mailNotification: customer.mailNotification ?? true,  // Default to true if undefined
        //         smsNotification: customer.smsNotification ?? false,   // Default to false if undefined
        //     }));
        //     // const selectedCustomer = [] as any;
        //     // state.data.selectedCustomers.forEach((customer: any) => {
        //     //     selectedCustomer.push(customer);
        //     // });
        //     const { id, name } = state.selectedChannel;
        //     const payLoad: Record<string, any> = {
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         estimation_id: props.estimationId,
        //         fields: state.fields,
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         approve_by_all: state.approveByAll,
        //         customers: selectedCustomer,
        //         signature: state.data.uploadSignature,
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         signature_link: state.data.signatureLink,
        //         note: state.data.note,
        //         acknowledgement: state.data.companyInfo.acknowledgement,
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         legal_statement: state.data.companyInfo.legal_statement,
        //         logo: state.data.companyInfo.logo,
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         ...(id ? { channel_id: id } : { channel_name: name })
        //     };
        //     state.ui.isPostLoading.sendJobEstimation = true;
        //     ethitransService
        //         .sendJobEstimation(payLoad)
        //         .then((res: any) => {
        //             // console.log(res);
        //             state.data.successFulMessage = t('send_job_estimation_successfully');
        //             state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
        //         })
        //         .catch((error: any) => {
        //             common
        //                 .sdCatchErr(error, state.ui.errors.errorList.sendJobEstimation)
        //                 .then((res: any) => {
        //                     state.ui.errors.hasError = true;
        //                     for (const [key, value] of Object.entries(res)) {
        //                         if (Array.isArray(value)) {
        //                             state.ui.errors.errorList.sendJobEstimation.push(value[0]);
        //                         }
        //                     }
        //                 });
        //         })
        //         .finally(() => {
        //             state.ui.isPostLoading.sendJobEstimation = false;

        //         });
        // }

        function sendJobEstimation() {
            state.ui.isPostLoading.sendJobEstimation = false;
            state.ui.errors.hasError = false;
            state.ui.isPostLoading.checkSignature = false;

            validateSendInvitation();
            if (state.ui.isPostLoading.sendJobEstimation || state.ui.errors.hasError) return false;

            if (state.ui.isPostLoading.sendJobEstimation || state.ui.errors.hasError) return false;

            const selectedCustomer = selectedMembers.value.map((customer: any) => {
                const phoneRaw = customer.user_mobile_number || customer.phone || '';
                const emailRaw = customer.user_email || customer.email || '';
                console.log("The eamil Raw is", emailRaw);

                const isValidPhone = phoneRaw && common.filterAndFormatUSPhoneNumber(phoneRaw);
                const isValidEmail = emailRaw && validationService.isValidEmail(emailRaw);

                const phone = isValidPhone ? common.filterAndFormatUSPhoneNumber(phoneRaw) : '';
                const email = (isValidEmail) ? emailRaw : '';

                return {
                    email,
                    code: email || phone,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    first_name: customer.user_first_name || customer.first_name || '',
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    last_name: customer.user_last_name || customer.last_name || '',
                    phone,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    address_line1: customer.address_line1 || '',
                    mailNotification: customer.mailNotification ?? false,
                    smsNotification: customer.smsNotification ?? false
                };
            });

            const { id, name } = state.selectedChannel;

            const payLoad: Record<string, any> = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                estimation_id: props.estimationId,
                // eslint-disable-next-line @typescript-eslint/camelcase
                fields: state.fields,
                // eslint-disable-next-line @typescript-eslint/camelcase
                approve_by_all: state.approveByAll,
                customers: selectedCustomer,
                signature: state.data.uploadSignature,
                // eslint-disable-next-line @typescript-eslint/camelcase
                signature_link: state.data.signatureLink,
                note: state.data.note,
                acknowledgement: state.data.companyInfo.acknowledgement,
                // eslint-disable-next-line @typescript-eslint/camelcase
                legal_statement: state.data.companyInfo.legal_statement,
                logo: state.data.companyInfo.logo,
                // eslint-disable-next-line @typescript-eslint/camelcase
                ...(id ? { channel_id: id } : { channel_name: name })
            };

            state.ui.isPostLoading.sendJobEstimation = true;

            ethitransService.sendJobEstimation(payLoad)
                .then((res: any) => {
                    state.data.successFulMessage = t('send_job_estimation_successfully');
                    state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
                })
                .catch((error: any) => {
                    common.sdCatchErr(error, state.ui.errors.errorList.sendJobEstimation)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.sendJobEstimation.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.sendJobEstimation = false;
                });
        }


        const totalCost = computed(() => {
            const total = state.selectItems.reduce((total: any, item: any) => total + parseFloat(item.total.replace(/[$,]/g, '').trim()), 0);
            return common.usdPriceFormate(total);
        });

        function showCreateCompanyModel() {
            $("#addCompanyInfo").modal("show");
        }

        function hideCreateCompanyModel() {
            state.ui.errors.errorList.createCompanyIfno = [];
            $("#addCompanyInfo").modal("hide");
            state.ui.isLoading.isCompanyEdit = false;
        }
        function editCompany() {
            state.ui.isLoading.isCompanyEdit = !state.ui.isLoading.isCompanyEdit;
            $("#addCompanyInfo").modal("show");
        }


        function showDelete(customer: any) {
            // Find index of the customer in both arrays
            const indexInAllCustomer = state.data.allCustomer.findIndex((item: any) => item.email === customer.email);
            const indexInSelectedCustomers = state.data.selectedCustomers.findIndex((item: any) => item.email === customer.email);

            // Remove from allCustomer array if exists
            if (indexInAllCustomer !== -1) {
                state.data.allCustomer.splice(indexInAllCustomer, 1);
            }

            // Remove from selectedCustomers array if exists
            if (indexInSelectedCustomers !== -1) {
                state.data.selectedCustomers.splice(indexInSelectedCustomers, 1);
            }
            const indexInPhoneCustomer = state.data.allPhones.findIndex((item: any) => item.phone === customer.phone);
            // remove from allphone array if exists
            if (indexInPhoneCustomer !== -1) {
                state.data.allPhones.splice(indexInPhoneCustomer, 1);
            }
        }


        function hideDelete() {
            $("#deleteModal").modal("hide");
        }
        function removeCustomer() {
            state.ui.isLoading.isRemoveCustomer = true;
            if (state.data.removeUser != null) {
                const customers = state.data.allCustomer.filter(function (user: any) {
                    return user.email == state.data.removeUser.email;
                })
            }
            state.data.allCustomer.length = 0;
            state.ui.isLoading.isRemoveCustomer = false;
            hideDelete();

        }
        function isEmailValid(item: any) {
            const email = item.email;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (email == localStorage.getItem("current_user_email")) {
                item.emailError = "Owner email  not valid here.";
                return false;
            }
            if (!emailRegex.test(email)) {
                item.emailError = "Please enter valid email.";
                return false;
            }
            item.emailError = "";
            return true;
        }

        function isPhoneValid(item: any) {
            const phone = item.phone;
            const phoneRegex = /^\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
            if (!phoneRegex.test(phone)) {
                item.phoneError = "Please enter valid phone.";
                return false;
            }
            item.phoneError = "";
            return true;
        }
        // function editSelectCustomer(index: number) {
        //     state.data.selectedCustomers.forEach((customer: any) => {
        //         customer.isEdit = false;
        //     });
        //     state.data.selectedCustomers[index].isEdit = true;
        // }
        const isEmail = (v: string) => /^[\w.-]+@([\w-]+\.)+[\w-]{2,}$/.test(v);
        function editSelectCustomer(member: any) {
            const selectedMember = member;
            state.data.customerToEdit = {
                ...selectedMember,
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_email: isEmail(member.user_email) ? member.user_email : '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_phone: member.user_phone || member.user_mobile_number || '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                isEmailDisabled: member.emailFromApi && !!member.user_email,
                // eslint-disable-next-line @typescript-eslint/camelcase
                isPhoneDisabled: member.phoneFromApi && !!(member.user_phone || member.user_mobile_number),
            }
            state.ui.showEditCustomerModal = true;
        }

        function closeEditCustomerModal() {
            state.ui.showEditCustomerModal = false;
            state.data.customerToEdit = null;
        }



        // function updateSelectCustomer(data: any) {

        //     const item = state.data.selectedCustomers[data];
        //     // eslint-disable-next-line @typescript-eslint/camelcase
        //     item.address_line1 = customer.address_line1 ? customer.address_line1 : item.address_line1;
        //     item.emailError = "";
        //     item.phoneError = "";
        //     if (item.phone) {
        //         if (isEmailValid(item)) {
        //             item.emailError = "";
        //             item.phoneError = "";
        //         }
        //         if (isPhoneValid(item)) {
        //             item.emailError = "";
        //             item.phoneError = "";
        //             item.isEdit = false;
        //         }
        //     } else {
        //         if (isEmailValid(item)) {
        //             item.emailError = "";
        //             item.phoneError = "";
        //             item.isEdit = false;
        //         }
        //     }
        //     if (item.smsNotification) {
        //         if (item.phone == undefined) {
        //             item.phoneError = "Enter phone number.";
        //             item.isEdit = true;
        //         } else if (item.phone.length != 10) {
        //             item.phoneError = "Phone number must be of 10 digit.";
        //             item.isEdit = true;
        //         }

        //     }

        // }
        function updateSelectCustomer() {
            const customer = state.data.customerToEdit;
            if (!customer) return;
            let hasError = false;

            // Clear previous errors
            customer.mailNotificationError = '';
            customer.smsNotificationError = '';
            customer.firstNameNotificationError = '';
            customer.lastNameNotificationError = '';

            if (!customer.user_first_name || !customer.user_first_name.trim()) {
                customer.firstNameNotificationError = 'First name is required.';
                hasError = true;
            }

            if (!customer.user_last_name || !customer.user_last_name.trim()) {
                customer.lastNameNotificationError = 'Last name is required.';
                hasError = true;
            }

            if (customer.mailNotification) {
                if (!customer.user_email) {
                    customer.mailNotificationError = 'Email is required when notify by email is selected.';
                    hasError = true;
                } else if (!isEmail(customer.user_email)) {
                    customer.mailNotificationError = 'Invalid email format.';
                    hasError = true;
                }
            }

            // Validate phone if notify by SMS is selected
            if (customer.smsNotification) {
                if (!customer.user_mobile_number) {
                    customer.smsNotificationError = 'Phone number is required when notify by SMS is selected.';
                    hasError = true;
                } else if (!formatPhone(customer.user_mobile_number)) {
                    customer.smsNotificationError = 'Invalid phone number format.';
                    hasError = true;
                }
            }

            if (hasError) return;

            // Deep copy to avoid mutation issues
            const updatedCustomer = JSON.parse(JSON.stringify(customer));

            // Update in selectedMemberss
            const index = state.data.selectedMembers.findIndex(
                (m: any) => m.user_id === updatedCustomer.user_id
            );

            if (index !== -1) {
                // Reactive replacement using splice
                state.data.selectedMembers.splice(index, 1, updatedCustomer);
            } else {
                // Add if not found
                state.data.selectedMembers.push(updatedCustomer);
            }

            closeEditCustomerModal();
        }







        function removeSelectCustomer(data: any) {
            state.data.selectedCustomers = state.data.selectedCustomers.filter(
                (e: any) => e != data
            );
            hideDelete();
        }

        function validateCreateCompany() {
            // console.log("*** TODO VALIDATION  ***");
            state.ui.errors.hasError = false;
            state.ui.errors.errorList.createCompanyIfno = [];
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            const companyEmail = state.data.companyInfo.company_email;
            if (
                !state.data.companyInfo.company_name &&
                !state.ui.isLoading.isCompanyEdit
            ) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company name is required."
                );
            }
            if (
                !state.data.companyInfo.company_email &&
                !state.ui.isLoading.isCompanyEdit
            ) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company Email is required."
                );
            }
            if (!companyEmail && !state.ui.isLoading.isCompanyEdit) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company Email is required."
                );
            } else if (companyEmail && !emailRegex.test(companyEmail)) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company Email must be a valid email address."
                );
            }
            if (!state.data.companyInfo.logo) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company logo is required."
                );
            }
            if (!state.data.companyInfo.acknowledgement) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company acknowledgement is required."
                );
            }
            // eslint-disable-next-line @typescript-eslint/camelcase
            if (!state.data.companyInfo.legal_statement) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company legal statement is required."
                );
            }
            if (
                !state.ui.errors.errorList.createCompanyIfno &&
                !state.ui.errors.errorList.createCompanyIfno.length
            ) {
                state.ui.errors.hasError = false;
            } else if (state.ui.errors.errorList.createCompanyIfno.length != 0) {
                state.ui.errors.hasError = true;
            }
        }
        //no profile set
        function createCompanyIfno() {
            state.ui.errors.errorList.createCompanyIfno = [];
            state.ui.errors.hasError = false;

            validateCreateCompany();

            if (state.ui.isPostLoading.createCompanyIfno) return false;
            if (
                state.ui.errors.hasError ||
                state.ui.errors.errorList.createCompanyIfno.length != 0
            )
                return false;

            if (state.ui.isLoading.isCompanyEdit) {
                hideCreateCompanyModel();
            }
            const payLoad: any = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                company_name: state.data.companyInfo.company_name,
                // eslint-disable-next-line @typescript-eslint/camelcase
                logo: state.data.companyInfo.logo,
                // eslint-disable-next-line @typescript-eslint/camelcase
                company_phone_number: state.data.companyInfo.company_phone_number,
                // eslint-disable-next-line @typescript-eslint/camelcase
                company_email: state.data.companyInfo.company_email,
                // eslint-disable-next-line @typescript-eslint/camelcase
                acknowledgement: state.data.companyInfo.acknowledgement,
                // eslint-disable-next-line @typescript-eslint/camelcase
                legal_statement: state.data.companyInfo.legal_statement,
            };
            state.ui.isPostLoading.createCompanyIfno = true;
            ethitransService
                .updateCompanyInfo(payLoad)
                .then((res: any) => {
                    hideCreateCompanyModel();
                })
                .catch((error: any) => {
                    console.log(error);
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createCompanyIfno)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createCompanyIfno.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.createCompanyIfno = false;
                });
        }

        function normalizeLogo(rawLogo: any): Promise<string> {
               return new Promise((resolve) => {
               let logo = rawLogo;

               // Parse JSON string if needed
               if (typeof logo === "string") {
               try {
               const parsed = JSON.parse(logo);
               if (parsed && parsed.file) logo = parsed.file;
               } catch (e) {
               // Not JSON, keep as is
               }
              } else if (logo && typeof logo === "object" && logo.file) {
              logo = logo.file;
             }

              // If it's API URL returning storage URL
             if (typeof logo === "string" && logo.includes("/api/v1/user/image/")) {
             fetch(logo)
              .then((res) => res.text())
              .then((finalUrl) => resolve(finalUrl || logo))
              .catch(() => resolve(logo));
            } else {
            resolve(logo);
            }
         });
        }


        function userStatus() {

            const payLoad = {
                email: localStorage.getItem("current_user_email"),
            };
            ethitransService
                .userStatus(payLoad)
                .then((res: any) => {
                    const company = res.data.data.company;
                     normalizeLogo(company.logo).then((logoUrl) => {
                     state.data.companyInfo.logo = logoUrl;
                     });
                    // state.data.companyInfo.logo = res.data.data.company.logo;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.company_name = res.data.data.company.company_name;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.company_phone_number = res.data.data.company.company_phone_number;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.company_email = res.data.data.company.company_email;
                    state.data.companyInfo.acknowledgement = res.data.data.company.acknowledgement;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.legal_statement = res.data.data.company.legal_statement;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.company_address = res.data.data.company.company_address;
                    // console.log("User Detail Check:>>> ", res.data.data);
                })
                .catch((error: any) => {
                    //   common
                    //     .sdCatchErr(error, state.ui.error.errorsList)
                    //     .then((res: any) => {
                    //       state.ui.error.hasError = true;
                    //       // console.log("CHECK for Error >>>", res)
                    //       for (const [key, value] of Object.entries(res)) {
                    //         if (Array.isArray(value)) {
                    //           state.ui.error.errorsList.push(value[0]);
                    //         }
                    //       }
                    //       // if (res) {
                    //       //   if (res.error) {
                    //       //     console.log("CHECK for Error >>>", res.error[0])
                    //       //     // state.errorList.push(res.email[0]);
                    //       //     // state.errorList = [...state.errorList]
                    //       //   }
                    //       // }
                    //     });
                })
                .finally(() => {
                    //   state.ui.isLoading.userStatus = true;
                });
        }

        function userSignature(from: any) {
            ethitransService
                .userSignature()
                .then((res: any) => {
                    if (from == 'onMount' && res.data.data.signature) {
                        state.data.haveProfileSign = true;
                    }
                    if (from == 'use' && res.data.data.signature) {
                        state.data.useProfileSign = true;
                        state.data.uploadSignature = "";
                        state.data.cropSignature = res.data.data.signature;
                        state.data.signatureLink = res.data.data.signature;
                    }
                })
                .catch((error: any) => {
                    //   common
                })
                .finally(() => {
                    //   state.ui.isLoading.userStatus = true;
                });
        }

        function startRecording(newValue: any) {
            // console.log('The New Value is>>', newValue)
            // state.data.note = state.data.note ? state.data.note : '' + ' ' + newValue;
            state.data.note = (state.data.note ? state.data.note + ' ' : '') + newValue;
            // console.log('The updated note data is>>', state.data.note)
        }

        function redirectToChat() {
            state.data.showChatChannelModal = !state.data.showChatChannelModal;
        }

        function hideChatChannel() {
            state.data.showChatChannelModal = !state.data.showChatChannelModal;
        }
        const handleChannelSelection = (channel: any) => {
            state.selectedChannel = channel;
        };

        function projectMembersList(uuid: string, isLoadMore = false) {
            console.log('Project Memberlist Project UUID is>>>', uuid);
            state.ui.isLoading.customerChannelMemberList = true
            ethitransService
                .projectMembersList(uuid)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const members = response.data || [];
                    if (members && members.length) {
                        state.ui.isHideChannelPart = true;
                    }
                    const taggedMembers = members.map((member: any) => ({
                        ...member,
                        emailFromApi: !!member.user_email && isEmail(member.user_email),
                        phoneFromApi: !!(member.user_mobile_number || member.user_phone),
                    }));


                    if (isLoadMore) {
                        // Prepend new members at the top
                        state.data.apiChannelMembers = [...taggedMembers, ...state.data.apiChannelMembers];
                    } else {
                        state.data.apiChannelMembers = taggedMembers;
                    }

                    // Save pagination info
                    state.ui.channelMemberPage = response.current_page;
                    state.ui.channelMemberLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    // customerChannelList();
                    state.ui.isLoading.customerChannelMemberList = false;
                });

        }

        function selectCustomerChannel(channelId = '', searchQuery = '', page = 1, isLoadMore = false) {
            // state.data.apiChannelMembers = [];
            state.ui.isLoading.customerChannelMemberList = true;
            state.data.selectedChannelUuid = channelId;

            ethitransService.customerChannelMemberList(channelId, searchQuery, 10, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const members = response.data || [];
                    const taggedMembers = members.map((member: any) => ({
                        ...member,
                        emailFromApi: !!member.user_email && isEmail(member.user_email),
                        phoneFromApi: !!(member.user_mobile_number || member.user_phone),
                    }));


                    if (isLoadMore) {
                        // Prepend new members at the top
                        state.data.apiChannelMembers = [...state.data.apiChannelMembers, ...taggedMembers];
                        console.log('Hello this isLoadMore', state.data.apiChannelMembers)

                    } else {
                        state.data.apiChannelMembers = taggedMembers;
                    }

                    // Save pagination info
                    state.ui.channelMemberPage = response.current_page;
                    state.ui.channelMemberLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.customerChannelMemberList = false;
                });
        }

        function projectMembersListAll(searchQuery = '', page = 1, isLoadMore = false) {
            // state.data.apiChannelMembers = [];
            state.ui.isLoading.customerChannelMemberList = true
            ethitransService
                .customerChannelMemberListAll(searchQuery, 10, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const members = response.data || [];
                    const taggedMembers = members.map((member: any) => ({
                        ...member,
                        emailFromApi: !!member.user_email && isEmail(member.user_email),
                        phoneFromApi: !!(member.user_mobile_number || member.user_phone),
                    }));


                    if (isLoadMore) {
                        // Prepend new members at the top
                        state.data.apiChannelMembers = [...state.data.apiChannelMembers, ...taggedMembers];
                    } else {
                        state.data.apiChannelMembers = taggedMembers;
                    }

                    // Save pagination info
                    state.ui.channelMemberPage = response.current_page;
                    state.ui.channelMemberLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    // customerChannelList();
                    state.ui.isLoading.customerChannelMemberList = false;
                });

        }


        function customerChannelList(searchQuery = '', perPage = 10, page = 1, isLoadMore = false) {

            state.ui.isLoading.customerChannelList = true;
            ethitransService.customerChannelList(projectId as any, searchQuery, perPage, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const channels = response.data || [];
                    console.log('Fetched Customer Channels:', channels);

                    if (isLoadMore) {
                        state.data.customerChannels = [...state.data.customerChannels, ...channels];
                    } else {
                        state.data.customerChannels = channels;
                        if (channels.length > 0) {
                            const firstChannelUuid = channels[0].uuid;
                            selectCustomerChannel(firstChannelUuid);
                            state.ui.isHideChannelPart = false;
                        }
                    }

                    // Save pagination info
                    state.ui.channelListLastPage = response.last_page;
                    state.ui.channelListPage = response.current_page;
                    console.log('The Project Id is >>', state.projectId)

                })
                .catch((error: any) => {
                    console.error('Error fetching customer channels:', error);
                })
                .finally(() => {
                    state.ui.isLoading.customerChannelList = false;
                });
        }


        function projectChannelList(projectId = '', searchQuery = '', perPage = 10, page = 1, isLoadMore = false) {
            console.log('Project UUID is:', projectId);
            state.ui.isLoading.projectChannelList = true;
            state.data.selectedProjectUuid = projectId;

            //  Clear previously selected channel and members
            state.data.selectedChannelUuid = '';
            state.data.apiChannelMembers = [];
            ethitransService.projectChannelList(projectId, searchQuery, perPage, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const channels = response.data || [];

                    if (isLoadMore) {
                        state.data.projectChannels = [...state.data.projectChannels, ...channels];
                    } else {
                        state.data.projectChannels = channels;

                        if (channels.length > 0) {
                            const firstChannelUuid = channels[0].uuid;
                            selectCustomerChannel(firstChannelUuid);
                            state.ui.isHideChannelPart = false;
                        } else {
                            // If no channels, clean everything
                            state.data.selectedChannelUuid = '';
                            state.data.apiChannelMembers = [];
                        }
                    }

                    state.ui.projectChannelPage = response.current_page;
                    state.ui.projectChannelLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.error('Error fetching project channels:', error);
                })
                .finally(() => {
                    state.ui.isLoading.projectChannelList = false;
                });
        }



        function customerProjectList(searchQuery = '', perPage = 10, page = 1, isLoadMore = false) {
            console.log('Search Query:', searchQuery);
            state.ui.isLoading.projectList = true;

            ethitransService.customerProjectList(searchQuery, perPage, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const projects = response.data || [];

                    console.log('Fetched Project List:', projects);

                    if (isLoadMore) {
                        // Prepend new items to the top
                        state.data.customerProjects = [...state.data.customerProjects, ...projects];
                    } else {
                        state.data.customerProjects = projects;

                        if (projects.length > 0) {
                            const firstProjectUuid = projects[0].uuid;
                            state.data.selectedProjectUuid = firstProjectUuid;
                            projectChannelList(firstProjectUuid);
                            state.ui.isHideChannelPart = false;
                        }
                    }

                    // Save pagination
                    state.ui.projectListPage = response.current_page;
                    state.ui.projectListLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.error('Error fetching customer projects:', error);
                })
                .finally(() => {
                    state.ui.isLoading.projectList = false;
                });
        }


        function removeSelectedMember(userId: number) {
            state.data.selectedMemberIds = state.data.selectedMemberIds.filter((id: any) => id !== userId)
            state.data.selectedMembers = state.data.selectedMembers.filter((m: any) => m.user_id !== userId)
        }
        function resetMemberPagination() {
            state.ui.channelMemberPage = 1;
            state.ui.channelMemberLastPage = 1;
        }

        const debouncedCustomerChannel = useDebouncedRef('', 700, (val) => {
            customerChannelList(val)
        })

        const debouncedChannelMembers = useDebouncedRef('', 700, (val) => {
            selectCustomerChannel(state.data.selectedChannelUuid, val)
        })

        const debouncedProjects = useDebouncedRef('', 700, (val) => {
            customerProjectList(val)
        })

        const debouncedProjectChannel = useDebouncedRef('', 700, (val) => {
            projectChannelList(state.data.selectedProjectUuid, val)
        })
        const debouncedMemberSearch = useDebouncedRef('', 700, (val) => {
            if (state.data.selectedFilterCustomerTab === 'member') {
                resetMemberPagination();
                projectMembersListAll(val);
            } else {
                selectCustomerChannel(state.data.selectedChannelUuid, val);
            }
        })

        function clearAllSearchInputs() {
            debouncedCustomerChannel.value = ''
            debouncedChannelMembers.value = ''
            debouncedProjects.value = ''
            debouncedProjectChannel.value = ''
            debouncedMemberSearch.value = ''
        }

        function handleFilterChange() {
            clearAllSearchInputs()
            if (state.data.selectedFilterProjectTab === 'channel') {
                customerChannelList();
            } else if (state.data.selectedFilterProjectTab === 'member') {
                projectMembersList(state.projectId);
            }
        }

        function handleFilterChangeAll() {
            clearAllSearchInputs()
            if (state.data.selectedFilterCustomerTab === 'channel') {
                state.data.channelMembers = [];
                state.ui.isHideChannelPart = false;
                customerProjectList();
            } else if (state.data.selectedFilterCustomerTab === 'member') {
                state.data.apiChannelMembers = [];
                state.data.selectedChannelUuid = '';
                state.ui.isHideChannelPart = true;
                projectMembersListAll();
            }
        }

        function allCustomerChannelList(searchQuery = '') {
            console.log('allCustomerChannelList API called:');
            state.ui.isLoading.customerChannelList = true;

            ethitransService.allCustomerChannelList(searchQuery)
                .then((res: any) => {
                    const channels = res.data.data.data || [];
                    console.log('Fetched Customer Channels:', channels);

                    state.data.customerChannels = channels;

                    if (channels.length > 0) {
                        const firstChannelUuid = channels[0].uuid;

                        state.data.apiChannelMembers = [];
                        selectCustomerChannel(firstChannelUuid);

                        state.ui.isHideChannelPart = false;
                    }
                })
                .catch((error: any) => {
                    console.error('Error fetching customer channels:', error);
                })
                .finally(() => {
                    state.ui.isLoading.customerChannelList = false;
                });
        }



        function resetForm() {
            state.form.firstName = ''
            state.form.lastName = ''
            state.form.contact = ''
        }
        const formatMobileNumber = (number: string) => {
            return `+1 (${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
        };



        const isPhone = (v: string) => /^\d{10}$/.test(v) || /^\+1 \(\d{3}\) \d{3}-\d{4}$/.test(v);

        const validate = () => {
            const f = state.form;
            state.errors.firstName = f.firstName.trim() ? '' : 'First name is required.';
            state.errors.lastName = f.lastName.trim() ? '' : 'Last name is required.';
            const c = f.contact.trim();
            state.errors.contact = !c
                ? 'Email or phone is required.'
                : !isEmail(c) && !isPhone(c)
                    ? 'Invalid email or phone.'
                    : '';
            return !state.errors.firstName && !state.errors.lastName && !state.errors.contact;
        };


        // const addCustomer = () => {
        //     if (!validate()) return;

        //     const contact = state.form.contact.trim();
        //     const formatted = /^\d{10}$/.test(contact) ? formatPhone(contact) : contact;

        //     const customer = {
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         user_id: Date.now(), // temp unique ID for local usage
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         user_first_name: state.form.firstName.trim(),
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         user_last_name: state.form.lastName.trim(),
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         user_email: isEmail(formatted) ? formatted : '',
        //         // eslint-disable-next-line @typescript-eslint/camelcase
        //         user_mobile_number: isEmail(formatted) ? '' : formatted,
        //         isFormAdded: true,
        //     };

        //     state.data.formAddedMembers.push(customer);
        //     state.data.selectedMemberIds.push(customer.user_id);
        //     state.data.selectedMembers.push(customer);


        //     // Reset form and errors
        //     state.form.firstName = '';
        //     state.form.lastName = '';
        //     state.form.contact = '';
        //     (Object.keys(state.errors) as Array<keyof typeof state.errors>).forEach(
        //         key => state.errors[key] = ''
        //     );
        //     // Trigger clear on custom input component (toggle pattern)
        //     clearInputValue.value = false;
        //     nextTick(() => {
        //         clearInputValue.value = true;
        //     });
        // };

        function cleanPhone(phone: string): string {
            return phone.replace(/\D/g, '');
        }

        const addCustomer = () => {
            if (!validate()) return;

            const contact = state.form.contact.trim();
            const formatted = /^\d{10}$/.test(contact) ? formatPhone(contact) : contact;

            const isEmailContact = isEmail(formatted);

            const isDuplicate = state.data.selectedMembers.some((member: any) => {
                const existing = isEmailContact
                    ? member.user_email?.toLowerCase()
                    : cleanPhone(member.user_mobile_number || '');
                const input = isEmailContact
                    ? formatted.toLowerCase()
                    : cleanPhone(formatted);
                return existing === input;
            });

            if (isDuplicate) {
                state.errors.contact = 'This contact is already selected.';
                return;
            }

            const customer = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_id: Date.now(),
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_first_name: state.form.firstName.trim(),
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_last_name: state.form.lastName.trim(),
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_email: isEmailContact ? formatted : '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_mobile_number: isEmailContact ? '' : formatted,
                isFormAdded: true,
                mailNotification: isEmailContact,
                smsNotification: !isEmailContact,
            };

            state.data.formAddedMembers.push(customer);
            state.data.selectedMemberIds.push(customer.user_id);
            state.data.selectedMembers.push(customer);

            // Reset form and errors
            state.form.firstName = '';
            state.form.lastName = '';
            state.form.contact = '';
            (Object.keys(state.errors) as Array<keyof typeof state.errors>).forEach(
                key => state.errors[key] = ''
            );

            clearInputValue.value = false;
            nextTick(() => {
                clearInputValue.value = true;
            });
        };


        function toggleMemberSelection(userId: number, event: Event) {
            const isChecked = (event.target as HTMLInputElement).checked
            const member = channelMembers.value.find((m: any) => m.user_id === userId)
                || state.data.formAddedMembers.find((m: any) => m.user_id === userId)

            if (!member) return

            if (isChecked) {
                if (!state.data.selectedMemberIds.includes(userId)) {
                    state.data.selectedMemberIds.push(userId)

                    const exists = state.data.selectedMembers.some((m: any) => m.user_id === member.user_id)
                    if (!exists) {
                        // Clone the member and set notification flags based on presence of email/phone
                        const selectedMember = {
                            ...member,
                            mailNotification: !!isEmail(member.user_email),
                            smsNotification: !!member.user_mobile_number,
                        }
                        state.data.selectedMembers.push(selectedMember)
                    }
                }
            } else {
                removeSelectedMember(userId)
            }
        }


        // function onChannelSearchInput(e: Event) {
        //     const value = (e.target as HTMLInputElement).value.trim();
        //     if (value === '') {
        //         state.ui.channelListPage = 1;
        //         state.ui.channelListLastPage = 1;
        //         customerChannelList(state.ui.searchQuery.customerChannel, 10, 1)
        //     }
        // }
        function onChannelSearchInput(e: Event) {
            const value = (e.target as HTMLInputElement).value.trim();
            state.ui.channelListPage = 1;
            state.ui.channelListLastPage = 1;
            const selectedProjectUuid = state.data.selectedProjectUuid;
            if (selectedProjectUuid) {
                projectChannelList(selectedProjectUuid, value, 10, 1);
            }
        }

        function onChannelMemberSearchInput(e: Event) {
            const value = (e.target as HTMLInputElement).value.trim();
            if (value === '') {
                state.ui.projectChannelPage = 1;
                state.ui.projectChannelLastPage = 1;
                projectChannelList(state.data.selectedProjectUuid);
            }
        }
        function onProjectSearchInput(e: Event) {
            const value = (e.target as HTMLInputElement).value.trim();
            if (value === '') {
                state.ui.projectListPage = 1;
                state.ui.projectListLastPage = 1;
                customerProjectList('', 10, 1);
            }
        }
        function handleChannelScroll(event: any) {
            // console.log('Hello handle channel scroll is working')
            const element = event.target;

           
            if (element.scrollTop + element.clientHeight >= element.scrollHeight) {
                // Load more only if not loading and more pages available
                if (state.ui.channelListPage < state.ui.channelListLastPage && !state.ui.isLoading.customerChannelList) {
                    customerChannelList(
                        state.ui.searchQuery.customerChannel,
                        10,
                        state.ui.channelListPage + 1,
                        true
                    );
                }
            }
        }


        function handleChannelMemberScroll(event: any) {
            const element = event.target;
        
            
            if (element.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
                if (
                    state.ui.channelMemberPage < state.ui.channelMemberLastPage &&
                    !state.ui.isLoading.customerChannelMemberList
                ) {
                    const nextPage = state.ui.channelMemberPage + 1;
                    selectCustomerChannel(
                        state.data.selectedChannelUuid,
                        state.ui.searchQuery.channelMembers,
                        nextPage,
                        true
                    );
                    console.log('selectCustomerChannel hitted')
                }
            }
        }
        function handleProjectScroll(event: any) {
            const el = event.target;
 
            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                if (
                    state.ui.projectListPage < state.ui.projectListLastPage &&
                    !state.ui.isLoading.projectList
                ) {
                    const nextPage = state.ui.projectListPage + 1;
                    customerProjectList(state.ui.searchQuery.projects, 10, nextPage, true);
                }
            }
        }

        function handleProjectChannelScroll(event: any) {
            const el = event.target;

            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                if (
                    state.ui.projectChannelPage < state.ui.projectChannelLastPage &&
                    !state.ui.isLoading.projectChannelList
                ) {
                    const nextPage = state.ui.projectChannelPage + 1;
                    projectChannelList(
                        state.data.selectedProjectUuid,
                        state.ui.searchQuery.customerChannel,
                        10,
                        nextPage,
                        true
                    );
                }
            }
        }

        const handleInput = (value: string) => {
            enteredValue.value = value;
            state.form.contact = value;
            // errorMessage.value = '';
        };



        watch(
            () => state.data.customerToEdit?.user_email,
            (newVal) => {
                if (!state.ui.showEditCustomerModal || !state.data.customerToEdit) return;

                state.data.customerToEdit.mailNotification = validationService.isValidEmail(newVal);
            }
        );

        watch(
            () => state.data.customerToEdit?.user_mobile_number,
            (newVal) => {
                if (!state.ui.showEditCustomerModal || !state.data.customerToEdit) return;
                const cleanedNumber = newVal?.replace(/[\s()-]/g, '');
                state.data.customerToEdit.smsNotification = validationService.validateMobileNumber(cleanedNumber);
            }
        );



        function switchTab(tab: string) {
            if (state.activeTab === tab) return;
            clearAllSearchInputs()
            state.ui.searchQuery.customerChannel = '';
            state.ui.searchQuery.channelMembers = '';
            state.ui.searchQuery.projects = '';
            if (tab === 'projectstb') {
                state.data.selectedFilterProjectTab = 'channel';
                customerChannelList();
            }

            if (tab === 'mycustomerstb') {
                state.data.selectedFilterCustomerTab = 'channel';
                customerProjectList();
            }

            state.activeTab = tab;
        }

        function onDynamicMemberScroll(event: any) {
            const el = event.target;

            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
                if (state.ui.isLoading.customerChannelMemberList) return;

                const nextPage = state.ui.channelMemberPage + 1;

                if (
                    state.data.selectedFilterCustomerTab === 'channel' &&
                    state.ui.channelMemberPage < state.ui.channelMemberLastPage
                ) {
                    selectCustomerChannel(
                        state.data.selectedChannelUuid,
                        state.ui.searchQuery.channelMembers,
                        nextPage,
                        true
                    );
                }

                if (
                    state.data.selectedFilterCustomerTab === 'member' &&
                    state.ui.channelMemberPage < state.ui.channelMemberLastPage
                ) {
                    projectMembersListAll(
                        state.ui.searchQuery.channelMembers,
                        nextPage,
                        true
                    );
                }
            }
        }


        onUnmounted(() => {
            document.body.style.overflow = ''
        })


        onMounted(() => {
            userStatus();
            getJobestimationDetail();
            userSignature('onMount');
            clearSignature();
            if (projectId) {
                customerChannelList();
            }

            // signaturePad = new SignaturePad(canvas.value);

        });

        return {
            state,
            redirectToChat,
            normalizeLogo,
            selectCustomerChannel,
            onChannelSearchInput,
            handleChannelMemberScroll,
            onChannelMemberSearchInput,
            onProjectSearchInput,
            handleProjectChannelScroll,
            debouncedMemberSearch,
            allCustomerChannelList,
            customerChannelList,
            handleChannelScroll,
            customerProjectList,
            projectChannelList,
            handleProjectScroll,
            selectedMembers,
            toggleMemberSelection,
            addCustomer,
            removeSelectedMember,
            handleFilterChange,
            projectMembersList,
            hideChatChannel,
            closePreviewModal,
            previewModal,
            estimationPreview,
            getJobestimationDetail,
            changeValue,
            isInvalid,
            addCustomerEmail,
            getProjectDetails,
            canvas,
            clearSignature,
            readImage,
            readSignature,
            onDocumentChange,
            showUploadImageModel,
            hideShowUploadImageModel,
            saveSignature,
            // enableSignaturPad,
            closeSuccessCustomModal,
            sendJobEstimation,
            validateSendInvitation,
            gotoListJobEstimation,
            totalCost,
            hideCreateCompanyModel,
            showCreateCompanyModel,
            createCompanyIfno,
            validateCreateCompany,
            editCompany,
            uploadLogo,
            readLogo,
            userStatus,
            showDelete,
            hideDelete,
            isEmailValid,
            isPhoneValid,
            removeSelectCustomer,
            editSelectCustomer,
            updateSelectCustomer,
            showSignaturePad,
            hideSignaturePad,
            uploadSignature,
            uploadSignatureFile,
            hideSignatureUpload,
            userSignature,
            startRecording,
            removeCustomer,
            fetchCustomerDetails,
            address,
            latitude,
            longitude,
            showMap,
            updateLatitude,
            updateLongitude,
            updateAddress,
            customer,
            changePhoneValue,
            addCustomerPhone,
            validateEmail,
            handleChannelSelection,
            signatureInput,
            closeEditCustomerModal,
            customerList,
            channelMembers,
            handleFilterChangeAll,
            clearInputValue,
            enteredValue,
            formatMobileNumber,
            handleInput,
            resetForm,
            switchTab,
            isEmail,
            projectMembersListAll,
            onDynamicMemberScroll,
            resetMemberPagination,
            debouncedCustomerChannel,
            debouncedChannelMembers,
            debouncedProjects,
            debouncedProjectChannel,
            clearAllSearchInputs,
            cleanPhone


        };
    },
});
